
import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const VoucherPopup = () => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setOpen(true);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent className="bg-dark border border-gold/30 text-gold-light max-w-lg w-[95vw] mx-auto rounded-xl p-0 overflow-hidden">
                <DialogHeader className="p-4 pb-0">
                    <DialogTitle className="text-2xl text-gold text-center">Wesołych Świąt!</DialogTitle>
                </DialogHeader>
                <div className="p-4 pt-2">
                    <video
                        src="/voucher.mp4"
                        controls
                        autoPlay
                        className="w-full rounded-lg shadow-lg"
                    >
                        Twoja przeglądarka nie obsługuje tagu wideo.
                    </video>

                    <div className="mt-4 flex justify-end">
                        <Button
                            onClick={() => setOpen(false)}
                            className="bg-gold text-dark hover:bg-gold-dark"
                        >
                            Zamknij
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default VoucherPopup;
